import React from "react";
import { reduxForm } from "redux-form";
import { connect } from "react-redux";
import { compose } from "redux";
import SmartRender from "containers/SmartRender";
import styles from "./styles";
import { createStructuredSelector } from "reselect";
import { submitNumberChange } from "ducks/actions";
import {
  makeSelectOldNumber,
  makeSelectNewNumber,
  makeSelectChangeNumberFee,
  makeSelectOrderDetails,
  makeSelectSubmitChangeNumberFormPayload,
  makeSelectFormattedChangeNumberDate
} from "ducks/selectors";
import { paths, forms } from "utils/constants";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import isFunction from "lodash/isFunction";
import validate from "validations";
import { gotoUrl } from "utils/helpers";

const ConfirmNumberChange = Component =>
  function Comp(props) {
    return <Component {...props} />;
  };

const mapStateToProps = createStructuredSelector({
  orderDetails: makeSelectOrderDetails(),
  oldNumber: makeSelectOldNumber(),
  newNumber: makeSelectNewNumber(),
  payTodayItems: makeSelectChangeNumberFee(),
  numberChangeFormPayload: makeSelectSubmitChangeNumberFormPayload(),
  styles: () => styles,
  formattedChangeNumberDate: makeSelectFormattedChangeNumberDate()
});

export function mapDispatchToProps(dispatch) {
  return {
    submitNumberChange: (params, callback) => {
      if (!isEmpty(params)) {
        dispatch(submitNumberChange(params, callback));
      }
    }
  };
}

export const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  messageData: {
    ...get(stateProps, "orderDetails", {}),
    oldNumber: get(stateProps, "oldNumber"),
    newNumber: get(stateProps, "newNumber"),
    totalPrice: get(stateProps, "payTodayItems.totalPrice"),
    cardNetwork: get(stateProps, "orderDetails.card_network"),
    cardNumber: get(stateProps, "orderDetails.credit_card_number"),
    formattedChangeNumberDate: get(stateProps, "formattedChangeNumberDate")
  },
  submitNumberChangeAndNavigate: navigate => {
    const params = get(stateProps, "numberChangeFormPayload");
    dispatchProps.submitNumberChange(params, (_, error) => {
      if (isEmpty(error)) {
        if (get(_, "code") !== -1) isFunction(navigate) && navigate();
        else {
          gotoUrl(paths.CHANGE_NUMBER_FAIL);
        }
      }
    });
  }
});

const withConnect = connect(mapStateToProps, mapDispatchToProps, mergeProps);

export default compose(
  withConnect,
  reduxForm({
    form: forms.CHANGE_NUMBER_FORM,
    validate: validate,
    destroyOnUnmount: false
  })
)(ConfirmNumberChange(SmartRender));
